import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: ({ context }) => {
    // Only treat actual dev builds as development.
    const isDevelopment = import.meta.env.DEV;

    // Wait for auth state to be fully loaded before making redirect decisions
    if (context.auth?.isInitialLoading) {
      // Don't redirect while still loading - let the component handle loading state
      return;
    }

    if (context.auth?.isAuthenticated) {
      // Check authorization: require super-admin or support claim (or dev mode) -
      // matches the backend's verifyAuthToken, which authorizes both roles.
      const isAuthorized = isDevelopment || context.auth?.isSuperAdmin || context.auth?.isSupport;

      if (isAuthorized) {
        throw redirect({
          to: "/dashboard",
        });
      } else {
        throw redirect({
          to: "/unauthorized",
        });
      }
    }
  },
  component: Index,
});

function Index() {
  return <div>Login to continue.</div>;
}
